import React, {useContext} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import { AuthContext } from '../../../contexts/authContext';
import config from '../../../config';
import axios from 'axios';
import DialogContentText from '@mui/material/DialogContentText';
import useNotification from '../../../hooks/useNotification';

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

function DeleteTickersDialog(props) {
    const auth = useContext(AuthContext);
    const { notificationSuccess, notificationError } = useNotification();

    const deleteTicker = async() => {
        try {
        
            if(!props.lastCellData.idEntita.S)return;

            const essentialData = {
                idEntita: props.lastCellData.idEntita.S,
                city: props.lastCellData.city.S,
            }

            const axiosParams = {
                url: '/delete-ticker',
                method: 'post',
                baseURL: config.API_URL,
                headers: {
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: essentialData
            };

            await axios(axiosParams);
            notificationSuccess('Ticker Eliminato');

            await props.getTickers();
            props.handleCloseDeleteTickersDialog();
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    return (
        <Dialog className="" open={props.openDeleteTickersDialog} onClose={props.handleCloseDeleteTickersDialog} PaperComponent={PaperComponent} >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Elimina ticker - {props?.lastCellData?.titolo.S}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Vuoi eliminare il ticker "{props?.lastCellData?.titolo.S || ''}"?
                </DialogContentText>
                <DialogContentText>L'azione è irreversibile.</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="standard" onClick={deleteTicker}>
                    Elimina
                </Button>
                <Button variant="outlined" autoFocus onClick={props.handleCloseDeleteTickersDialog}>
                    Annulla
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DeleteTickersDialog